<template>
  <div class="dialog-body">
    <h1>Edit Profile</h1>

    <div class="info-container">
      <div class="form-sec">
        <form method="post" :action="url" novalidate="novalidate">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="required-label">FULL NAME (as perMyKad or Passport)</label>
                <input
                  type="text"
                  class="form-control"
                  id="full_name"
                  placeholder="Fill in your name"
                  name="full_name"
                  required
                >
              </div>
              <div class="form-group">
                <label class="required-label">SIGNUP COUNTRY</label>
                <select class="form-control" id="country" name="country">
                  <option value>Select Country</option>
                  <option></option>
                </select>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label class="required-label">MYKAD OR PASSPORT NUMBER</label>
                    <input
                      type="text"
                      class="form-control"
                      id="ic_passport"
                      placeholder="Fill in your IC or passport"
                      name="ic_passport"
                    >
                  </div>
                  <div class="col-lg">
                    <label class="required-label">NATIONALITY</label>
                    <select class="form-control col" id="nationality" name="nationality">
                      <option>Select Nationality</option>
                      <option
                        v-for="(nationality, idx) in this.dataNationalities"
                        :key="idx"
                        :value="nationality"
                      >{{ nationality }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="required-label">EMAIL ADDRESS</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder="Enter email"
                  name="email"
                  v-model="email"
                  maxlength="191"
                >
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label class="required-label">MOBILE NUMBER</label>
                    <input
                      type="text"
                      class="form-control"
                      id="mobile"
                      placeholder="Enter phone number"
                      name="mobile"
                      v-model="mobile"
                      maxlength="12"
                    >
                  </div>
                  <div class="col-lg">
                    <label class="required-label">DATE OF BIRTH</label>
                    <select class="form-control" id="nationality" name="nationality">
                      <option>Select Nationality</option>
                      <option>$nationality }}</option>
                    </select>
                    <!-- <input
                  type="text"
                  class="form-control"
                  id="dob"
                  placeholder="Fill in your date of birth"
                  name="dob"
                    >-->
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-4">
                    <label>UNIT NUMBER</label>
                    <input type="text" class="form-control" id="unit_number" name="unit_number">
                  </div>
                  <div class="col-lg">
                    <label>BUILDING NAME</label>
                    <input type="text" class="form-control" id="building_name" name="building_name">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="required-label">STREET NAME</label>
                <input type="text" class="form-control" id="street_name" name="street_name">
              </div>
              <div class="form-group">
                <label class="required-label">SUBURB/CITY</label>
                <input type="text" class="form-control" id="city" name="city">
              </div>
              <div class="form-group">
                <label class="required-label">STATE</label>
                <div class="input-group">
                  <select class="form-control" id="state" name="state">
                    <option value>Select State</option>
                    <option value="Johor">Johor</option>
                    <option value="Kedah">Kedah</option>
                    <option value="Kelantan">Kelantan</option>
                    <option value="Labuan">Labuan</option>
                    <option value="Melaka">Melaka</option>
                    <option value="Negeri Sembilan">Negeri Sembilan</option>
                    <option value="Pahang">Pahang</option>
                    <option value="Perak">Perak</option>
                    <option value="Perlis">Perlis</option>
                    <option value="Pulau Pinang">Pulau Pinang</option>
                    <option value="Putrajaya">Putrajaya</option>
                    <option value="Sabah">Sabah</option>
                    <option value="Sarawak">Sarawak</option>
                    <option value="Selangor">Selangor</option>
                    <option value="Terengganu">Terengganu</option>
                    <option value="Kuala Lumpur">Kuala Lumpur</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="required-label">POSTCODE</label>
                <input type="text" class="form-control" id="postcode" name="postcode">
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-blue">SAVE CHANGES</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // Note: data-email and data-mobile becomes camel case in props
  props: [
    "dataProfile",
    "dataEmail",
    "dataMobile",
    "dataCountries",
    "dataStates",
    "dataNationalities"
  ],
  data() {
    return {
      url: this.$routes["member_update_contact"],
      email: this.dataEmail,
      mobile: this.dataMobile,
      isSubmitting: false,
      errorMessage: ""
    };
  },
  methods: {
    // async submitForm() {
    //     this.isSubmitting = true;
    //     this.errorMessage = '';
    //     var result = await this.$asyncPost(, {
    //         'email': this.email,
    //         'mobile': this.mobile
    //     });
    //     this.isSubmitting = false;
    //     if (result.status == 'success') {
    //         Swal.fire({
    //           type: 'success',
    //           title: 'Success',
    //           text: result.message,
    //         }).then(() => {
    //             this.$redirect(this.$routes['member_profile']);
    //         });
    //     } else {
    //         this.errorMessage = result.message;
    //     }
    // }
  },
  computed: {
    parseObject: function(stuff) {
      return JSON.parse(stuff);
    }
  }
};
</script>
